<template>
	<tr>
		<td v-if="index" width="8%" :rowspan="rowspan" class="py-1 pl-2">{{ index }}</td>
		<td
			:colspan="colspan"
			:width="index ? '12%' : '20%'"
			:class="!index && colspan == 1 ? 'py-1 pl-2 border-left' : 'py-1 pl-2'"
		>
			{{ name }}
		</td>
		<td width="60%" class="py-1 pl-2">
			<slot name="value">
				<p v-if="text" class="pre-wrap" v-text="value"></p>
				<template v-else>
					{{ value }}
				</template>
			</slot>
		</td>
		<td width="20%" class="py-1">
			<v-checkbox
				hide-details
				v-model="checked"
				:rules="requireCheck ? [(v) => !!v || 'チェックが必要です'] : []"
				label="確認"
			/>
		</td>
	</tr>
</template>

<script>
import common from "../../helper/common"
import rules from "../../helper/rules"

export default {
	props: {
		name: {
			type: String,
			required: true,
			default: "",
		},
		value: {
			type: null,
			required: false,
			default: "",
		},
		index: {
			type: Number,
			required: false,
		},
		rowspan: {
			type: Number,
			required: false,
			default: 1,
		},
		colspan: {
			type: Number,
			required: false,
			default: 2,
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
		requireCheck: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			checked: false,
			common,
			rules,
		}
	},
}
</script>

<style lang="scss" scoped>
th,
td {
	border-left: solid gray 1px;
	&:first-child {
		border-left: none;
	}
}
.border-left {
	border-left: solid gray 1px !important;
}
tr {
	border-bottom: solid gray 1px;
}
td td {
	white-space: pre-wrap;
}
</style>
